import React, { useState, useEffect } from "react"

export const AudioSettingsContext = React.createContext()

export const useAudioSettingsContext = () => {
  const context = React.useContext(AudioSettingsContext)
  if (context === undefined) {
    throw new Error(
      "useAudioSettingsContext must be used within a AudioSettingsProvider"
    )
  }
  return context
}

const AudioSettingsProvider = ({ children, onSettingsChanged }) => {
  const [audioSettings, setAudioSettings] = useState({})

  useEffect(() => {
    const getAudioSettings = async () => {
      setAudioSettings({
        volume: 100,
        speed: 1,
        speedLabel: "x1",
        micId: null,
      })
    }
    getAudioSettings().catch(console.log)
  }, [])

  useEffect(() => {
    if (onSettingsChanged) {
      onSettingsChanged(audioSettings)
    }
  }, [audioSettings])

  return (
    <AudioSettingsContext.Provider value={{ audioSettings, setAudioSettings }}>
      {children}
    </AudioSettingsContext.Provider>
  )
}

export default AudioSettingsProvider
